import { ImageSourcePropType } from 'react-native';

import { Nullable, SetState } from '@rbi-ctg/frontend';
import { IRestaurant } from '@rbi-ctg/store';
import { ServiceMode } from 'generated/graphql-gateway';
import { IServiceModeHeading } from 'utils/service-mode/types';
export { ServiceMode };

export type ServiceModeStatus = {
  [key in ServiceMode]: {
    /**
     * store is available in MDM
     */
    capable: boolean;
    /**
     * store is available if store hours are within service mode availability
     * and the store supports this service mode type
     */
    available: boolean;
    /**
     * state is disabled based on flag from LD, separate from store's availability
     */
    disabled: boolean;
    /**
     * store hours are open within service mode availability
     */
    open?: boolean;
    /**
     * If today's opening hours are not set, it'll contain tomorrow's opening hours (which could be `null`).
     * If set and the store hasn't opened yet, contains the opening hours for the current;
     * otherwise, contains the opening hours for tomorrow.
     */
    nextOpeningHours: string | null;
  };
};

export interface IServiceModeCtx {
  serviceMode: Nullable<ServiceMode>;
  selectServiceMode: (serviceMode: ServiceMode | null) => void;
  setDeliverySurchargeFee: SetState<number | null>;
  isDelivery: boolean;
  isTakeout: boolean;
  isEatIn: boolean;
  isMobileOrderForDriveThru: boolean;
  isDriveThru: boolean;
  getServiceModeOptions: (store: IRestaurant) => ServiceModeOption[];
}

export type ServiceModeOption = IServiceModeHeading & {
  name: ServiceMode;
  image: ImageSourcePropType | undefined;
  description: string;
  isSelected: boolean;
  isAvailable?: boolean;
};
